import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import Container from "@scentregroup/ui/components/container";
import Card from "@scentregroup/ui/components/card";
import Heading from "@scentregroup/ui/components/heading";
import Paragraph from "@scentregroup/ui/components/paragraph";
import classNames from 'classnames';
import AutoPotentialLink from '../auto-potential-link';
import Article from '../article';
import RetailerUtilityBox from '../../components/retailer-utility-box';
import Markdown from '../markdown';
import CentreUtilityBox from '../centre-utility-box';
import { CustomThemeContext } from '../../context';
import ResponsiveAsset from '../responsive-asset';
import { matchMedia } from '../../helpers/match-media';
import Trackable from '../trackable';
import { trackingActions, trackingTypes } from '../../constants';
import { occurrencesType, callToActionType } from './../../types';
import style from './index.module.scss';
import wMaskStyle from './w-mask.module.scss';
import WMask from './w-mask.inline.svg';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MAXIMUM_MASK_LOAD_TIME = 3500;
class Feature extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "startMaskAnimation", () => {
      if (this.maskLoadTimeout) {
        clearTimeout(this.maskLoadTimeout);
      }
      if (this.showMaskQuery.matches) {
        this.setState({
          animateMask: true
        });
      } else {
        this.hideMask();
      }
    });
    _defineProperty(this, "maskAnimationDone", event => {
      if (event.animationName === wMaskStyle.maskAnimZoomIn || event.animationName === wMaskStyle.maskAnimFadeOut) {
        this.hideMask();
      }
    });
    _defineProperty(this, "hideMask", () => {
      this.setState({
        showMask: false,
        animateMask: false
      });
    });
    this.state = {
      showMask: props.withMask,
      animateMask: false
    };
    this.maskLoadTimeout = null;
    this.showMaskQuery = props.withMask ? matchMedia('(orientation: portrait)') : null;
  }
  componentDidMount() {
    // Make sure the mask goes away if the feature image takes too long to load
    if (this.props.withMask) {
      this.maskLoadTimeout = setTimeout(this.hideMask, MAXIMUM_MASK_LOAD_TIME);
    }
  }
  render() {
    const {
      position,
      desktopImageUrl,
      mobileImageUrl,
      videoUrl,
      topic,
      title,
      entryType,
      body,
      link,
      centred,
      terms,
      retailerUtility,
      location,
      occurrences,
      utilityPanelModule,
      lazyLoad,
      callsToAction,
      shareButtonType,
      withMask,
      infoAccordion,
      pastEventsAccordion,
      priceInfo,
      analyticsMetadata
    } = this.props;
    const {
      showMask,
      animateMask
    } = this.state;
    const ariaLabel = topic ? "".concat(topic, " - ").concat(title) : title;
    return /*#__PURE__*/_jsx(Trackable, _objectSpread(_objectSpread({
      trackingAction: trackingActions.viewPromotion,
      type: trackingTypes.promotion
    }, analyticsMetadata), {}, {
      "data-id": "feature_index_Trackable",
      children: /*#__PURE__*/_jsx(CustomThemeContext.Consumer, {
        children: themeOption => /*#__PURE__*/_jsx("div", {
          className: classNames(style.featureWrapper, style.evolved),
          "data-id": "feature_index_div",
          children: /*#__PURE__*/_jsxs("div", {
            className: classNames(style.Feature, {
              [style.placeholder]: !desktopImageUrl || !mobileImageUrl,
              [style.Grey]: themeOption.luxury,
              [wMaskStyle.maskedContainer]: showMask,
              [wMaskStyle.moveTheMask]: showMask && animateMask
            }),
            onAnimationEnd: this.maskAnimationDone,
            "data-id": "feature_index_div_div_2",
            children: [Boolean(desktopImageUrl && mobileImageUrl) && /*#__PURE__*/_jsx(AutoPotentialLink, {
              link: link,
              "aria-label": ariaLabel,
              "data-id": "feature_index_AutoPotentialLink",
              children: /*#__PURE__*/_jsx(ResponsiveAsset, {
                angleOrigin: null,
                className: classNames(style.evolvedAsset, {
                  [wMaskStyle.maskedImage]: showMask
                }),
                desktopImageUrl: desktopImageUrl,
                mobileImageUrl: mobileImageUrl,
                videoUrl: videoUrl,
                mobileRatio: "square",
                desktopRatio: "square",
                numberOfItems: 1,
                alt: title,
                lazyLoad: lazyLoad,
                dataTestId: "featured-image",
                onLoad: withMask ? this.startMaskAnimation : null,
                onError: withMask ? this.hideMask : null,
                "data-id": "feature_index_AutoPotentialLink_ResponsiveAsset"
              })
            }), /*#__PURE__*/_jsxs(Container, {
              centred: true,
              type: "large",
              className: classNames(style.Container, style[position], {
                [wMaskStyle.maskedContent]: showMask
              }),
              "data-id": "feature_index_div_Container",
              children: [/*#__PURE__*/_jsx(Card, {
                className: classNames(style.Card, {
                  [style.centred]: centred
                }),
                "data-id": "feature_index_Container_Card",
                children: /*#__PURE__*/_jsxs(AutoPotentialLink, {
                  className: style.addLinkStyles,
                  link: link,
                  "aria-label": ariaLabel,
                  "data-id": "feature_index_Card_AutoPotentialLink",
                  children: [entryType && /*#__PURE__*/_jsx(Heading, {
                    type: "extrasmall",
                    className: style.superHeading,
                    "data-test-id": "featured-type",
                    "data-id": "feature_index_Heading",
                    children: entryType
                  }), /*#__PURE__*/_jsxs(Article, {
                    shareButtonType: shareButtonType,
                    superheading: topic,
                    heading: title,
                    headingType: "large",
                    location: location,
                    occurrences: occurrences,
                    callsToAction: callsToAction,
                    infoAccordion: infoAccordion,
                    pastEventsAccordion: pastEventsAccordion,
                    priceInfo: priceInfo,
                    headerDataTestId: "featured-type",
                    dataTestId: "featured-title",
                    "data-id": "feature_index_AutoPotentialLink_Article",
                    children: [/*#__PURE__*/_jsx(Markdown, {
                      content: body,
                      customRenderers: () => ({
                        paragraph: _ref => {
                          let {
                            children
                          } = _ref;
                          return /*#__PURE__*/_jsx(Paragraph, {
                            className: style.articleParagraph,
                            "data-id": "feature_index_Paragraph",
                            children: children
                          });
                        }
                      }),
                      "data-id": "feature_index_Article_Markdown"
                    }), terms && /*#__PURE__*/_jsx(Markdown, {
                      content: terms,
                      "data-id": "feature_index_Markdown"
                    })]
                  })]
                })
              }), utilityPanelModule && /*#__PURE__*/_jsx("div", {
                className: style.Sidebar,
                "data-id": "feature_index_div",
                children: /*#__PURE__*/_jsx(CentreUtilityBox, _objectSpread(_objectSpread({}, utilityPanelModule), {}, {
                  origin: 'feature',
                  "data-id": "feature_index_div_CentreUtilityBox"
                }))
              }), retailerUtility && /*#__PURE__*/_jsx("div", {
                className: style.Sidebar,
                "data-id": "feature_index_div",
                children: /*#__PURE__*/_jsx(RetailerUtilityBox, _objectSpread(_objectSpread({}, retailerUtility), {}, {
                  "data-id": "feature_index_div_RetailerUtilityBox"
                }))
              })]
            }), showMask && /*#__PURE__*/_jsx(WMask, {
              className: wMaskStyle.wDeviceMask,
              "data-id": "feature_index_WMask"
            })]
          })
        })
      })
    }));
  }
}
Feature.defaultProps = {
  centred: false,
  terms: '',
  retailerUtility: null,
  lazyLoad: true,
  isTopFeature: false
};
export default Feature;